import {
  FloatingPortal,
  autoPlacement,
  autoUpdate,
  shift,
  useFloating,
} from '@floating-ui/react';
import React, { useEffect, useRef } from 'react';

import UserOverview from '~/components/UserOverview';

import { useChat } from './ChatContext';
import styles from './ChatOverview.scss';
import OverviewButtons from './OverviewButtons';

const ChatOverview = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { overviewUser, activeOverview, hideOverview } = useChat();

  const { refs, floatingStyles } = useFloating({
    middleware: [autoPlacement(), shift()],
    whileElementsMounted: autoUpdate,
  });

  useEffect(() => {
    const onClickWindow = (e) => {
      if (e.target === activeOverview?.current || e.target === ref) return;
      if (e.target.className === 'profile-image') return;
      hideOverview();
    };

    window.addEventListener('click', onClickWindow);
    return () => window.removeEventListener('click', onClickWindow);
  }, []);

  useEffect(() => {
    if (!activeOverview || !activeOverview.current) return;
    refs.setReference(activeOverview.current);
  }, [activeOverview?.current]);

  if (!overviewUser || !activeOverview?.current) return null;

  return (
    <FloatingPortal>
      <div
        className={styles.ChatUserOverview}
        style={floatingStyles}
        ref={(el) => {
          refs.setFloating(el);
          ref.current = el;
        }}
      >
        <UserOverview user={overviewUser} style={{ position: 'relative' }}>
          <OverviewButtons user={overviewUser} />
        </UserOverview>
      </div>
    </FloatingPortal>
  );
};

export default ChatOverview;
